import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { TermsAndConditionsClient } from "../../parentApi";

const client = new TermsAndConditionsClient(app_uri, axiosClient());

export default client;
